import { SVG, SVGProps } from './svg'

export function IconToolElliottWave(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M26.12 6.48c0 .33-.28.6-.62.6a.6.6 0 110-1.2.6.6 0 01.62.6zM26.03 12.54c0 .33-.21.55-.53.55-.32 0-.53-.22-.53-.55v-4.2c0-.35.21-.57.53-.57.32 0 .53.22.53.56v4.2zM11.67 15.1a2 2 0 10-3.08.31l-4.02 6.84a.5.5 0 10.86.5l4.02-6.83a2 2 0 001.47-.15l6.41 7.12a2 2 0 103.08-.31l4.02-6.83a.5.5 0 00-.86-.5l-4.02 6.83a2 2 0 00-1.47.15l-6.41-7.12zM11 14a1 1 0 11-2 0 1 1 0 012 0zm8 11a1 1 0 100-2 1 1 0 000 2z"
      />
    </SVG>
  )
}
